import { COMPANIES_URLS, getCompaniesUrls } from 'api/config';
import $api from 'api/http';
import { TCompanyParams } from 'store/types';

export default class CompaniesService {
    static async create(data: {
        name: string;
        user: {
            firstName: string;
            lastName: string;
            email: string;
        };
    }) {
        return $api.post(getCompaniesUrls({ reqName: COMPANIES_URLS.create }), data);
    }
    static async companies() {
        return $api.get(getCompaniesUrls({ reqName: COMPANIES_URLS.companies }));
    }
    static async invite(params: TCompanyParams) {
        return $api.post(getCompaniesUrls({ reqName: COMPANIES_URLS.invite, ...params }));
    }
    static async remove(params: TCompanyParams) {
        return $api.post(getCompaniesUrls({ reqName: COMPANIES_URLS.remove, ...params }));
    }
    static async company(params: TCompanyParams) {
        return $api.post(getCompaniesUrls({ reqName: COMPANIES_URLS.company, ...params }));
    }
    static async users(params: TCompanyParams) {
        return $api.get(getCompaniesUrls({ reqName: COMPANIES_URLS.users, ...params }));
    }
    static async update(params: TCompanyParams & { name: string }) {
        return $api.post(getCompaniesUrls({ reqName: COMPANIES_URLS.update, ...params }), { name: params.name });
    }
    static async delete(params: TCompanyParams) {
        return $api.post(getCompaniesUrls({ reqName: COMPANIES_URLS.delete, ...params }));
    }
}
